function attention_modal() {
    const modal = document.getElementById("modal");
    const openBtn = document.getElementsByClassName("open-modal")[0];

    openBtn.addEventListener("click", (e) => {
        e.preventDefault();
        modal.style.display = "block";
    });

    // 背景クリックで閉じる
    modal.addEventListener("click", (e) => {
        if (e.target === modal) {
            modal.style.display = "none";
        }
    });

    // はいを選択したとき
    let submitButton = document.getElementById("modalSubmit");
    submitButton.addEventListener('click', function () {
        // 回答を送信するため一時保存していたデータを削除する
        localStorage.removeItem("question");

        // フォームを送信する
        let form = document.querySelector("form");
        form.submit();
    });

    // いいえを選択したとき
    let closeButton = document.getElementById("modalClose");
    closeButton.addEventListener('click', function () {
        modal.style.display = "none";
    });
}

export function attentionModalTool() {
    attention_modal();
}
